import React from "react";

const Dccb = () => {
  return (
    <div className="w-full">
      {/* Header */}
      <h1 className="text-center text-3xl font-bold text-[#003B73] mt-10 mb-6">
        District Central Cooperative Banks (DCCBs)
      </h1>

      {/* Overview Section */}
      <section className="bg-blue-50 p-10 rounded-xl max-w-7xl mx-auto mb-16">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Overview</h2>
        <div className="border-l-4 border-blue-600 pl-6">
          <p className="text-gray-700 leading-relaxed mb-4">
            District Central Cooperative Banks (DCCBs) form the second tier of
            the cooperative banking network. Operating at the district level,
            they bridge the gap between the Apex Bank and Primary Agricultural
            Cooperative Credit Societies (PACCS).
          </p>
          <p className="text-gray-700 leading-relaxed">
            DCCBs are crucial for delivering agricultural, rural, and retail
            banking services to communities across Tamil Nadu.
          </p>
        </div>
      </section>

      {/* What DCCBs Do */}
      <section className="max-w-7xl mx-auto mb-20 px-6">
        <h2 className="text-3xl font-bold text-center text-slate-800 mb-12">
          What DCCBs Do
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            "Provide credit to farmers through PACCS",
            "Support agricultural operations, farm inputs, and crop loans",
            "Facilitate government welfare schemes and subsidies",
            "Offer deposits, savings, and recurring deposit products",
            "Extend loans to small businesses and rural enterprises",
            "Oversee and strengthen primary societies in their jurisdiction",
          ].map((item, index) => (
            <div
              key={index}
              className="bg-teal-600 rounded-2xl shadow-lg p-8 transform transition hover:scale-105"
            >
              <p className="text-white font-semibold text-lg">{item}</p>
            </div>
          ))}
        </div>
      </section>
<section className="bg-slate-100 py-10 w-full">
  <h2 className="text-2xl font-bold text-center text-[#0B1F3A] mb-6">
    Focus Areas
  </h2>

  <div className="flex flex-wrap justify-center gap-6 w-full max-w-[75%] mx-auto">
    {[
      "Crop Loans",
      "Kisan Credit Cards",
      "Farm Mechanisation Support",
      "Self-Help Group Financing",
      "Rural Small Enterprise Loans",
    ].map((area, index) => (
      <div
        key={index}
        className="
          flex-1
          min-w-[150px]
          max-w-[200px]
          aspect-square
          rounded-full
          bg-blue-200
          text-[#0B1F3A]
          flex items-center justify-center text-center
          px-4
          font-semibold text-base
          shadow-md hover:shadow-lg
          transition transform hover:-translate-y-1
        "
      >
        {area}
      </div>
    ))}
  </div>
</section>

    </div>
  );
};

export default Dccb;